export const MEDIA_VARIANTS = Object.freeze({
  TILE: 'icon_32',
  TILE_DETAIL: 'thumb_256',
  TILE_TEXTURE: 'thumb_256',
  ENTITY_ICON: 'icon_64',
  CARD: 'card_160',
  MODAL: 'thumb_256',
  PICTURE: 'picture_512',
  REGION: 'picture_768',
  HERO: 'hero_1280',
  VIDEO_PREVIEW: 'preview',
  ENTITY_POSTER: 'poster_256',
  REGION_POSTER: 'poster_640',
  AVATAR: 'avatar_1x',
  AVATAR_2X: 'avatar_2x',
  AVATAR_THUMB: 'avatar_thumb',
  AVATAR_MAP: 'avatar_map',
  AVATAR_MAP_2X: 'avatar_map_2x',
});

const VARIANT_DIMENSIONS = Object.freeze({
  icon_32: [32, 32],
  icon_64: [64, 64],
  card_160: [160, 160],
  thumb_256: [256, 256],
  picture_512: [512, 512],
  picture_768: [768, 432],
  hero_1280: [1280, 720],
  poster_128: [128, 128],
  poster_256: [256, 256],
  poster_640: [640, 360],
  avatar_1x: [384, 512],
  avatar_2x: [768, 1024],
  avatar_thumb: [192, 256],
  avatar_map: [48, 64],
  avatar_map_2x: [96, 128],
});

export function resolveMediaVariant(variant, size) {
  if (variant) return variant;
  return size === 'small' ? MEDIA_VARIANTS.MODAL : MEDIA_VARIANTS.PICTURE;
}

export function resolveAvatarPortraitVariant(devicePixelRatio = 1) {
  const pixelRatio = Number(devicePixelRatio);
  return Number.isFinite(pixelRatio) && pixelRatio > 1
    ? MEDIA_VARIANTS.AVATAR_2X
    : MEDIA_VARIANTS.AVATAR;
}

export function mediaCacheKey(mediaId, variant) {
  return `${mediaId || ''}::${variant || ''}`;
}

export function mediaPath(mediaId, variant) {
  if (!mediaId) return null;
  const query = variant ? `?variant=${encodeURIComponent(variant)}` : '';
  return `/media/${encodeURIComponent(mediaId)}${query}`;
}

export function mediaDimensions(variant) {
  return VARIANT_DIMENSIONS[variant] || [512, 512];
}
